/**
 * Проверяет, является ли ошибка результатом отмены запроса
 * @param {Error} error - объект ошибки
 * @returns {boolean}
 */
export const isCancelledError = error => {
    if (!error) return false

    return (
        error.name === 'CanceledError' ||
        error.name === 'AbortError' ||
        error.code === 'ERR_CANCELED' ||
        error.message?.includes('cancel') ||
        error.message?.includes('abort')
    )
}


// Маршруты
const ROUTE_ERROR_MESSAGES = {
  deleteRoute: {
    conflict: 'Невозможно удалить маршрут: некорректное состояние',
    fallback: 'Ошибка при удалении маршрута',
  },
  addOrdersToRoute: {
    conflict: 'Невозможно добавить заказы: некорректное состояние',
    fallback: 'Ошибка при добавлении заказов в маршрут',
  },
  removeOrdersFromRoute: {
    conflict: 'Невозможно удалить заказы из маршрута: некорректное состояние',
    fallback: 'Ошибка при удалении заказов из маршрута',
  },
  transferOrdersToRoute: {
    conflict: 'Невозможно перенести заказы: некорректное состояние',
    fallback: 'Ошибка при переносе заказов в другой маршрут',
  },
  assignCourier: {
    conflict: 'Невозможно назначить курьера: некорректное состояние',
    fallback: 'Ошибка при назначении курьера',
  },
  unassignCourier: {
    conflict: 'Невозможно снять курьера: некорректное состояние',
    fallback: 'Ошибка при снятии курьера с маршрута',
  },
  startRoute: {
    conflict: 'Невозможно отправить маршрут: некорректное состояние',
    fallback: 'Ошибка при отправке маршрута',
  },
  completeRoute: {
    conflict: 'Невозможно завершить маршрут: некорректное состояние',
    fallback: 'Ошибка при завершении маршрута',
  },
}

export function handleRouteError(error, actionKey) {
  const status = error.response?.status
  const responseData = error.response?.data
  const messages = ROUTE_ERROR_MESSAGES[actionKey] || {}

  if (status === 404) {
    console.error('Маршрут не найден', responseData)
    throw error
  }

  if (status === 409) {
    console.error(
      messages.conflict || 'Невозможно выполнить действие: некорректное состояние',
      responseData
    )
    throw error
  }

  console.error(
    messages.fallback || 'Ошибка при работе с маршрутом',
    error
  )
  throw error
}